import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { StatusChip } from "shared";
import { Employee } from "entitites/employees/model/employee";

export const PersonalBodyView = ({ employee }: { employee: Employee }) => {
  return (
    <Box width="100%" display="flex" gap={0.25} flexDirection="column">
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Статус
        <Box sx={{ ml: "auto", width: 300 }}>
          <StatusChip
            title={employee.personalInfo.status.name}
            color={employee.personalInfo.status.color}
          />
        </Box>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Личная почта
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.personalInfo.personalEmail}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Почта
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.personalInfo.email}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Личный телефон
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.personalInfo.personalPhone}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Телефон
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.personalInfo.phone}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Телеграм
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.personalInfo.telegram}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Город
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.personalInfo.city}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Дата рождения
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.personalInfo.dob}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Адрес
        <Typography sx={{ ml: "auto", width: 300 }}>
          {employee.personalInfo.address}
        </Typography>
      </Box>
      {employee.personalInfo.additionalFields.map((field) => (
        <Box
          key={field.id}
          display="flex"
          alignItems="center"
          fontWeight={600}
          width="100%"
        >
          <Typography minWidth={255} maxWidth={255} noWrap fontWeight={600}>
            {field.label}
          </Typography>
          <Typography sx={{ ml: "auto", width: 300 }}>{field.value}</Typography>
        </Box>
      ))}
    </Box>
  );
};
